import { useViewerMetadata } from 'domains/viewer/Viewer/StudyLoader/useViewerMetadata';
import analytics from 'modules/analytics';
import { globalContext } from 'modules/analytics/constants';
import { useEffect } from 'react';
import { atom, useSetRecoilState } from 'recoil';

export const openedViewersState = atom<Readonly<string[]>>({
  key: 'openedViewersState',
  default: [],
});

export const TrackOpenedViewers = ({ children }: { children: React.ReactNode }) => {
  const setOpenedViewers = useSetRecoilState(openedViewersState);
  const { openWindowsIds } = useViewerMetadata();

  useEffect(() => {
    setOpenedViewers(openWindowsIds);
    analytics.addContext(globalContext.viewer.windowsOpen, openWindowsIds?.length);
    analytics.addContext(globalContext.viewer.openWindowsIds, openWindowsIds);
  }, [setOpenedViewers, openWindowsIds]);

  return children;
};
